import { frontendURL } from 'dashboard/helper/URLHelper';
import FunnelReport from './FunnelReport.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports/funnel'),
      name: 'reports_funnel',
      component: FunnelReport,
      meta: { permissions: ['administrator', 'agent'], featureFlag: 'crm' },
    },
  ],
};
